// extracted by mini-css-extract-plugin
module.exports = {"blockFooter":"footer-of-personal-area_blockFooter__2BE--","content":"footer-of-personal-area_content__2gatX","contentText":"footer-of-personal-area_contentText__KRDvh"};